import { Button, List, Divider } from 'antd';
import { Link } from 'react-router-dom';
import React from 'react';
import HowToBook from '../assets/images/icons/HowToBook';
import HowToBookOutline from '../assets/images/icons/HowToBookOutline';
import MobileAvailabilityIcon from '../assets/images/icons/MobileAvailabilityIcon';
import DesktopAvailabilityIcon from '../assets/images/icons/DesktopAvailabilityIcon';
import ViewSiteMap from '../assets/images/icons/ViewSiteMap';
import ViewSiteMapOutline from '../assets/images/icons/ViewSiteMapOutline';
import CheckLocalWeather from '../assets/images/icons/CheckLocalWeather';
import CheckLocalWeatherOutline from '../assets/images/icons/CheckLocalWeatherOutline';
import Icon from '@ant-design/icons';

export function LabelledRoundButton({
  icon,
  label,
  onClick = undefined,
  href = undefined,
}) {
  const button = (
    <div className={'fs-12 txt-center'}>
      <Button
        className={'mg-auto-lr'}
        shape='circle'
        icon={icon}
        size='large'
        onClick={onClick}
      />
      <p className={'black gMedium mg-top-3'}>{label}</p>
    </div>
  );

  if (href) {
    return <Link to={href}>{button}</Link>;
  }
  return button;
}

export default function FisheryProfileQuickLinks({
  fisheryPublicId,
  isDirectoryProfile = false,
  isPackageBooking = false,
  small = false,
}) {
  console.log(isPackageBooking);
  let links = [];
  if (!isDirectoryProfile) {
    links = [
      !isPackageBooking && {
        icon: <MobileAvailabilityIcon />,
        smallIcon: <Icon component={() => <DesktopAvailabilityIcon />} />,
        text: 'Check Live Availability',
        shortText: 'Availability',
        className: 'dark-green',
        href: '/live-availability',
      },
      {
        icon: <HowToBook />,
        smallIcon: <Icon component={() => <HowToBookOutline />} />,
        text: 'Click Here For a Guide On How To Book',
        shortText: 'Guide',
        className: 'sb-blue',
        href: '/how-to-book',
      },
      {
        icon: <ViewSiteMap />,
        smallIcon: <ViewSiteMapOutline />,
        text: 'View Location Sitemap',
        shortText: 'Sitemap',
        className: 'sb-blue',
        href: '/sitemap',
      },
    ];
  }
  links.push({
    icon: <CheckLocalWeather />,
    smallIcon: <CheckLocalWeatherOutline />,
    text: 'Check Local Weather',
    shortText: 'Weather',
    className: 'sb-blue',
    href: '/weather',
  });

  if (small) {
    return (
      <div
        className={
          'fishery_profile__quick_links fishery_profile__quick_links--small'
        }
      >
        {links.map((item) => (
          <LabelledRoundButton
            icon={item.smallIcon}
            label={item.shortText}
            href={`/fishery/${fisheryPublicId}${item.href}`}
          />
        ))}
      </div>
    );
  }

  return (
    <List
      className={'fishery_profile__quick_links'}
      size={'small'}
      dataSource={links}
      renderItem={(item) => (
        <>
          <List.Item>
            <List.Item.Meta avatar={item.icon} />
            <Link
              to={`/fishery/${fisheryPublicId}${item.href}`}
              className={item.className + ' gSemiBold txt-underline fs-15'}
            >
              {item.text}
            </Link>
          </List.Item>
          {item.shortText === 'Availability' && (
            <Divider
              style={{
                margin: ' 10px 0',
              }}
            ></Divider>
          )}
        </>
      )}
    />
  );
}
